module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/square/text_white-1363e80dfa5d0e52ae69c093769fc9a3.png";